import React from 'react';

const CronHelperText = () => (
  <span className='helper-text'>
    Quartz Cron Expression; <a
      href='http://www.quartz-scheduler.org/documentation/quartz-2.x/tutorials/crontrigger.html'
      target='_blank'
      rel='noopener noreferrer'
      style={{ textDecoration: 'none' }}
    >
      Documentation Here
    </a>
  </span>
);

export default CronHelperText;
